'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var IconWrapper = require('../IconWrapper.js');

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React__default.createElement(IconWrapper.default, _extends({
    viewbox: 18,
    type: "info"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M17 9A8 8 0 1 1 1 9a8 8 0 1 1 16 0zM3 9c0 3.309 2.691 6 6 6s6-2.691 6-6-2.691-6-6-6-6 2.691-6 6z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8 9c0-.552.444-1 1-1 .552 0 1 .444 1 1v3c0 .552-.444 1-1 1-.552 0-1-.444-1-1V9zm1-4c.552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1 0-.552.444-1 1-1z"
  })));
};

process.env.NODE_ENV !== "production" ? SvgInfo.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string
} : void 0;
SvgInfo.IsIcon = true;

exports.default = SvgInfo;
